module.exports = __webpack_public_path__ + "assets/img/meneg1.c3a28d16.png";